import * as z from "zod/v4";

export const deleteAddress = {
  name: "deleteAddress" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ success: z.boolean() }),
};
